import React from 'react';
import { ContactForm, Hero } from '../components/Main/Contact';

const Contact = () => {
  return (
    <>
      <Hero />
      <ContactForm />
    </>
  );
};

export default Contact;
